export default __webpack_public_path__ + "b22cfa2662fb67024c092aed47b4dab1.jpg";